import addresses from '1stdibs-contracts/addresses.json' with { type: 'json' };

const AuctionV1Addresses = addresses.FirstDibsAuction;

type AuctionV1AddressType = keyof typeof AuctionV1Addresses;

const auctionV1Addresses = Object.keys(AuctionV1Addresses).map(network =>
    AuctionV1Addresses[network as AuctionV1AddressType].address?.toLowerCase()
);

export const isV1Auction = (auctionContractAddress?: string | null): boolean => {
    if (!auctionContractAddress) {
        return false;
    }
    return auctionV1Addresses.includes(auctionContractAddress?.toLowerCase());
};
